<template>
<!-- 导入客户管理 -->
<section class="viewContainer">
  <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
    <el-tab-pane label="全部客户" name="first"/>
    <el-tab-pane label="销售记录" name="second"/>
    <el-tab-pane label="登记黑名单" name="third"/>
  </el-tabs>

  <!-- 全部客户 -->
  <div v-show="activeName=='first'">
    <!-- 顶部搜索框 -->
    <div class="main_container">
      <div class="fuji" @click="show3 = !show3">
        <div class="goodslist1">
          <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
          <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
        </div>
        <div style="position: absolute;right:0;top:-10px" class="sanjiao"/>
      </div>
      <el-collapse-transition>
      <div v-show="show3">
        <el-form class="findform">
          <el-form-item label="创客电话：" style="display:flex;width:30%">
            <el-input  v-model="orderNumber" placeholder="请输入创客手机号码" maxlength="30" style="width:90%;"/>
          </el-form-item>
          <el-form-item label="客户手机号码：" label-width="50px" style="display:flex;width:30%">
            <el-input  v-model="khphone" placeholder="请输入客户手机号码" maxlength="30" style="width:90%;"/>
          </el-form-item>
          <el-form-item label="所属城市：" style="display:flex;width:30%">
            <el-cascader v-model="chengshi" :options="options" placeholder="请选择城市"
            filterable clearable @change="handleChange" style="width:90%"/>
          </el-form-item>
          <el-form-item> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
        </el-form>
      </div>
      </el-collapse-transition>
    </div>
    <!-- 列表 -->
    <div class="main_container">
      <section class="model_section">
        <p class="model_top_title">全部客户</p>
      </section>
      <div class="table_container">
        <el-table :data="chargebackList" stripe border>
          <el-table-column prop="num" label="序号" align="center" width="60">
            <template scope="scope">{{scope.$index + 1}}</template>
          </el-table-column>
          <el-table-column label="创客手机号码" align="center" width="130">
            <template scope="scope">{{scope.row.userphone}}</template>
          </el-table-column>
          <el-table-column label="所属城市" align="center">
            <template scope="scope">{{scope.row.cityname}}</template>
          </el-table-column>
          <el-table-column label="客户姓名" align="center">
            <template scope="scope">{{scope.row.customername}}</template>
          </el-table-column>
          <el-table-column label="客户手机号码" align="center" width="130">
            <template scope="scope">{{scope.row.customerphone}}</template>
          </el-table-column>
          <el-table-column label="户型" align="center">
            <template scope="scope">{{scope.row.housetypename}}</template>
          </el-table-column>
          <el-table-column label="面积" align="center">
            <template scope="scope">{{scope.row.floorspace}}</template>
          </el-table-column>
          <el-table-column label="客户需求" align="center" width="150">
            <template scope="scope">
              <span class="spanList" :title="scope.row.cluetypes">{{scope.row.cluetypes}}</span>  
            </template>
          </el-table-column>
          <el-table-column label="需求描述" align="center" width="180">
            <template scope="scope">
              <span class="spanList" :title="scope.row.remark" v-if="scope.row.remark">{{ scope.row.remark }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="购买周期（天）" align="center" width="130">
            <template scope="scope">{{scope.row.cyclename}}</template>
          </el-table-column>
          <el-table-column label="登记日期" align="center" width="120">
            <template scope="scope">{{scope.row.regtime}}</template>
          </el-table-column>
          <el-table-column label="销售次数" align="center" width="100">
            <template scope="scope">{{scope.row.sellcount}}</template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" align="center" width="200">
            <template slot-scope="scope">
              <span class="handle" @click="showBillWatch(scope.row)"> <i class="el-icon-view"></i>销售记录</span>
              <span class="handle" @click="addPartner(scope.row)"> <i class="el-icon-edit-outline"/> 编辑 </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" @current-change="currentchangeOne"
        :page-size="10" :total="totalOne" :current-page="pageIndexOne" style="margin:10px 0;float:right;"/>
      </div>
    </div>
  </div>

  <!-- 销售记录 -->
  <div v-show="activeName=='second'">
    <!-- 顶部搜索框 -->
    <div class="main_container">
      <div class="fuji" @click="show3 = !show3">
        <div class="goodslist1">
          <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
          <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
        </div>
        <div style="position: absolute;right:0;top:-10px" class="sanjiao"/>
      </div>
      <el-collapse-transition>
      <div v-show="show3">
        <el-form class="findform">
          <el-form-item label="商家名称：" style="display:flex;width:30%">
            <el-input  v-model="shangjianame" placeholder="请输入商家店铺名称或个人商家手机号码" maxlength="30" style="width:90%;"/>
          </el-form-item>
          <!-- <el-form-item label="购买店铺：" style="display:flex;width:35%" class="select">
            <el-select v-model="shztid" placeholder="请选择" filterable style="width:90%;">
              <el-option v-for="(item,index) in shztArr" :key="index" :value="item.id" :label="item.name"/>
            </el-select>
          </el-form-item> -->
          <el-form-item label="购买时间：" style="display:flex;width:30%">
            <el-date-picker type="daterange" v-model="orderTime" @change="changetime" style="width:90%;"
            value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"/>
          </el-form-item>
          <el-form-item> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
        </el-form>
      </div>
      </el-collapse-transition>
    </div>
    <!-- 列表 -->
    <div class="main_container">
      <section class="model_section">
        <p class="model_top_title">销售记录</p>
      </section>
      <div class="table_container">
        <el-table :data="blacklist" stripe border>
          <el-table-column label="序号" align="center" width="60">
            <template scope="scope">{{scope.$index + 1}}</template>
          </el-table-column>
          <el-table-column label="客户姓名" align="center">
            <template scope="scope">{{scope.row.customername}}</template>
          </el-table-column>
          <el-table-column label="城市" align="center">
            <template scope="scope">{{scope.row.provincename}}-{{scope.row.cityname}}</template>
          </el-table-column>
          <el-table-column label="客户号码" align="center">
            <template scope="scope">{{scope.row.phone}}</template>
          </el-table-column>
          <el-table-column label="户型" align="center">
            <template scope="scope">{{scope.row.housetypename}}</template>
          </el-table-column>
          <el-table-column label="面积" align="center">
            <template scope="scope">{{scope.row.floorspace}}</template>
          </el-table-column>
          <el-table-column label="客户需求" align="center">
            <template scope="scope">{{scope.row.cluetypename}}</template>
          </el-table-column>
          <el-table-column label="需求描述" align="center" width="160">
            <template scope="scope">
              <span class="spanList" :title="scope.row.customerremark" v-if="scope.row.customerremark">{{ scope.row.customerremark }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="购买周期（天）" align="center" width="120">
            <template scope="scope">{{scope.row.cyclename}}</template>
          </el-table-column>
          <el-table-column label="登记日期" align="center">
            <template scope="scope">{{scope.row.regtime}}</template>
          </el-table-column>
          <el-table-column label="资源售价（元）" align="center" width="120">
            <template scope="scope">{{scope.row.price}}</template>
          </el-table-column>
          <el-table-column label="购买商家名称" align="center" width="120">
            <template scope="scope">
              <span class="spanList" :title="scope.row.name">{{scope.row.name}}</span>
            </template>
          </el-table-column>
          <el-table-column label="购买时间" align="center">
            <template scope="scope">{{scope.row.paytime}}</template>
          </el-table-column>
          <el-table-column label="平台佣金(元)" align="center" width="120">
            <template scope="scope">{{scope.row.platformprice}}</template>
          </el-table-column>
          <el-table-column label="备注" align="center" width="200">
            <template scope="scope">{{scope.row.remark}}</template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" @current-change="currentchangeTwo"
        :page-size="10" :total="totalTwo" :current-page="pageIndexTwo" style="margin:10px 0;float:right;"/>
      </div>
    </div>
  </div>
  <!-- 登记黑名单 -->
  <div v-show="activeName=='third'">
    <!-- 顶部搜索框 -->
    <div class="main_container">
      <div class="fuji" @click="show3 = !show3">
        <div class="goodslist1">
          <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
          <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
        </div>
        <div style="position: absolute;right:0;top:-10px" class="sanjiao"/>
      </div>
      <el-collapse-transition>
      <div v-show="show3">
        <el-form class="findform">
          <el-form-item label="创客电话：" style="display:flex;width:30%">
            <el-input  v-model="chuangkephone" placeholder="请输入创客手机号码" maxlength="11" style="width:90%;"/>
          </el-form-item>
          <el-form-item label="登记状态：" style="display:flex;width:35%" class="select">
            <el-select v-model="djztid" placeholder="请选择" filterable style="width:90%;">
              <el-option v-for="(item,index) in djztArr" :key="index" :value="item.id" :label="item.name"/>
            </el-select>
          </el-form-item>
          <el-form-item label="省份城市：" style="display:flex;width:30%">
            <el-cascader v-model="chengshi" :options="options" placeholder="请选择城市"
            filterable clearable @change="handleChange" style="width:90%"/>
          </el-form-item>
          <el-form-item> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
        </el-form>
      </div>
      </el-collapse-transition>
    </div>
    <!-- 列表 -->
    <div class="main_container">
      <section class="model_section">
        <p class="model_top_title">全部创客</p>
        <div style="float: right;margin: 0 10px 0 0;color: #F56C6C;">重要提示：本功能用于对恶意登记客源创客进行黑名单管理，加入黑名单创客则无法正常添加客源。</div>
      </section>
      <div class="table_container">
        <el-table :data="djhmdlist" stripe border>
          <el-table-column label="序号" align="center" width="60">
            <template scope="scope">{{scope.$index + 1}}</template>
          </el-table-column>
          <el-table-column label="创客电话" align="center">
            <template scope="scope">{{scope.row.phone}}</template>
          </el-table-column>
          <el-table-column label="创客所属城市" align="center">
            <template scope="scope">{{scope.row.pname}}-{{scope.row.cname}}</template>
          </el-table-column>
          <el-table-column label="登记客源数" align="center">
            <template scope="scope">{{scope.row.customernum}}</template>
          </el-table-column>
          <el-table-column label="登记状态" align="center">
            <template scope="scope">{{scope.row.status==1?'黑名单':'正常'}}</template>
          </el-table-column>
          <el-table-column label="最近一次操作时间" align="center">
            <template scope="scope">{{scope.row.lasttime}}</template>
          </el-table-column>
          <el-table-column label="操作" align="center" fixed="right">
            <template scope="scope">
              <span style="color: #F56C6C;" @click="handlehmd(scope.row)" v-show="scope.row.status==2"><i class="el-icon-circle-plus-outline"/>加入黑名单</span>
              <span class="handle" @click="handlehmd(scope.row)" v-show="scope.row.status==1"><i class="el-icon-remove-outline"/>移除黑名单</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" @current-change="currentchangethree"
        :page-size="10" :total="totalthree" :current-page="pageIndexthree" style="margin:10px 0;float:right;"/>
      </div>
    </div>
  </div>

  <!-- 销售记录 右侧抽屉组件 -->
  <el-drawer title="销售记录" custom-class="registrationRecord" :visible.sync="isBillWatch" size="30%">
    <el-table :data="seeLlnrList" border style="margin: 0px">
      <el-table-column label="序号" align="center" width="50">
        <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
      </el-table-column>
      <el-table-column label="销售时间" property="selltime" align="center"/>
      <el-table-column label="购买商家名称" property="shopname" align="center"/>
      <el-table-column label="购买的需求" property="cluetypename" align="center"/>
    </el-table>
    <!-- 销售记录-分页 -->
    <el-col :span="24" style="margin-top:15px;float:right" class="order_toolbar_footer">
      <el-pagination layout="prev, pager, next" @current-change="handlethjl"
      :current-page="pageIndexXsjl" :page-size="10" :total="pagetotal" style="float: right; margin-top: 10px"/>
    </el-col>
  </el-drawer>
  
  <!-- 编辑 右侧抽屉组件 -->
  <el-drawer title="编辑" custom-class="registrationRecord" :visible.sync="isInfor" size="40%">
    <div style="display: flex;justify-content: space-between;margin-bottom: 10px;margin-top: -10px;">
      <b>客户信息：</b>
      <span style="color: #F56C6C;">登记日期：{{createtime}}</span>
    </div>
    <el-form style="display: flex; flex-wrap: wrap;">
      <el-form-item label="客户姓名：" style="display: flex;width: 33.33%;margin-bottom: 10px;">
        <el-input v-model="khname" placeholder="请输入客户姓名" maxlength="20" style="width: 90%;" disabled/>
      </el-form-item>
      <el-form-item label="手机号码：" style="display: flex;width: 33.33%;margin-bottom: 10px;">
        <el-input v-model="sjhm" placeholder="请输入手机号码" maxlength="11" style="width: 90%;" disabled/>
      </el-form-item>
      <el-form-item label="所在城市：" style="display: flex;width: 33.33%;margin-bottom: 10px;">
        <el-cascader v-model="szcsid" placeholder="请选择所在城市" :options="csOptions"
          filterable clearable @change="changeszcs" style="width:100%;" disabled/>
      </el-form-item>
      <el-form-item label="小区名称：" style="display: flex;width: 33.33%;margin-bottom: 10px;">
        <el-input v-model="xqname" placeholder="请输入小区名称" maxlength="20" style="width: 90%;" disabled/>
      </el-form-item>
      <el-form-item label="房屋户型：" style="display: flex;width: 33.33%;margin-bottom: 10px;">
        <el-input v-model="fwhx" placeholder="请选择房屋户型" style="width: 90%;" disabled/>
      </el-form-item>
      <el-form-item label="房屋面积：" style="display: flex;width: 33.33%;margin-bottom: 10px;">
        <el-input v-model="fwmj" placeholder="请输入房屋面积" maxlength="20" style="width: 100%;" disabled>
          <i slot="suffix" style="margin-right: 10px;line-height: 36px;">㎡</i>
        </el-input>
      </el-form-item>
    </el-form>
    <div style="display: flex; margin-bottom: 10px;">
      <b>客户需求:</b> <span>（多选）</span>
    </div>
    <div style="display: flex; flex-wrap: wrap;">
      <div v-for="(option, index) in khxqOption" :key="option.cluetypeid"
      :style="{ flex: (index % 2 === 0 && index + 1 === khxqOption.length) ||
      (index % 2 === 0 && khxqOption[index + 1] === undefined) ? '0 0 50%' : '0 0 33.33%' }">
        <div style="display: flex;margin: 0 15px 15px 0;">
          <div class="khxqcheckbox"><el-checkbox v-model="option.selected"/></div>
          <span class="khxqspan">{{ option.cluetypename }}</span>
          <el-input placeholder="请输入内容" v-model="option.price" disabled>
            <i slot="suffix" style="margin-right: 10px;line-height: 36px;">元</i>
          </el-input>
        </div>
      </div>
    </div>

    <div style="display: flex; margin-bottom: 10px;">
      <b>需求周期：</b>
    </div>
    <div style="width: 100%;display: flex;flex-wrap: wrap;">
      <!--  @click="selectItem(index)" -->
      <div v-for="(item, index) in items" :key="item.id" class="xqzqclass"
        :class="{ 'selected': selectedIndex === index }">
        <span style="font-size: 14px;">{{ item.days }}</span>
      </div>
    </div>

    <el-form>
    <el-form-item label="需求描述：（选填）">
      <!-- placeholder="请输入需求描述，最多输入100个字" -->
      <el-input type="textarea" v-model="desc" :rows="3" maxlength="100" show-word-limit disabled/>
    </el-form-item>
    </el-form>
    <el-checkbox v-model="invalidCustomer" :disabled="youxiao!=1" style="margin-bottom: 30px;color: #F56C6C;">设置为无效客户（谨慎操作）</el-checkbox>
    <div style="text-align:center">
      <el-button @click="isInfor = false">取消</el-button>
      <el-button type="danger" @click="editSubmit()">确定</el-button>
    </div>
  </el-drawer>
  
</section>
</template>
<script>
import { userIdentity, provincegetcountys } from '../../api/newOss';
import { usercustomergetlist, getsellrecord, shopcustomercluegetlist, djhmdpostlist, qxdjhmd,
  cluegettypes, customergetinfo, customerchan } from "../../api/shopWindow";
export default {
  data() {
    return {
      show3: true, // 查询区域默认展开
      activeName: 'first', // tab切换标识
      orderNumber: "", // 创客电话
      khphone: '', // 客户手机号
      chengshi: '', // 省份城市
      provinceId: 0, // 省
      cityId: 0, // 市
      optionsindex: "",
      options: [
        {
          value: 0,
          label: "全部"
        }
      ],
      chargebackList: [], // 全部客户
      pageIndexOne: 1, // 页码
      totalOne: 0, // 总条数
      customerid: "", // 客户ID
      isBillWatch: false, // 抽屉-通话记录
      seeLlnrList: [], // 抽屉列表
      pageIndexXsjl: 1, // 页码
      pagetotal: 0, // 总条数

      shangjianame: '', // 商家名称
      shztid: '', // 购买店铺
      shztArr: [], // 店铺集合
      orderTime: "", // 申请时间
      beginTime: "", // 开始时间
      endTime: "", // 结束时间
      blacklist: [], // 销售记录
      pageIndexTwo: 1, // 页码
      totalTwo: 0, // 总条数
      
      chuangkephone: '', // 创客电话
      djztid: 0, // 登记状态
      djztArr: [
        {
          id: 0,
          name: "全部"
        },{
          id: 1,
          name: "黑名单"
        },{
          id: 2,
          name: "正常"
        }
      ],
      djhmdlist: [], // 全部创客
      pageIndexthree: 1,
      totalthree: 0,
      
      isInfor: false, // 编辑
      createtime: '', // 登记日期
      khname: '',
      sjhm: '',
      
      shengId: 0,
      shiId: 0,
      qxId: 0,
      szcsid: [],
      csOptions: [],

      xqname: '',
      fwhx: '',
      fwmj: '',

      khxqOption: [], // 客户需求动态选项
      
      desc: '', // 需求描述
      items: [
        { id: 1, days: '7天' },
        { id: 2, days: '15天' },
        { id: 3, days: '30天' },
        { id: 4, days: '2个月' },
        { id: 5, days: '3个月' },
        { id: 6, days: '4个月' },
        { id: 7, days: '5个月' },
        { id: 8, days: '6个月以上' },
      ],
      selectedIndex: 0, // 默认选中第一项
      invalidCustomer: false, // 无效客户
      youxiao: '', // 有效
    };
  },
  methods: {
    // 切换tab
    handleClick(tab){
      if(tab.name=='first'){
        this.orderNumber = "", // 创客电话
        this.khphone = '', // 客户手机号
        this.pageIndexOne = 1;
        this.getorder();
      }else if(tab.name=='second'){
        this.shangjianame = ''; // 商家名称
        this.shztid = '', // 购买店铺
        this.orderTime = "", // 申请时间
        this.beginTime = "", // 开始时间
        this.pageIndexTwo = 1;
        this.gethmd();
      }else{
        this.shangjianame = ''; // 商家名称
        this.shztid = '', // 购买店铺
        this.pageIndexthree = 1;
        this.getdjhmd();
      }
    },
    // 查询
    onSubmit() {
      if(this.activeName=='first'){
        this.pageIndexOne = 1;
        this.getorder();
      }else if(this.activeName=='second'){
        this.pageIndexTwo = 1;
        this.gethmd();
      }else{
        this.pageIndexthree = 1;
        this.getdjhmd();
      }
    },
    // 获取全部客户列表
    getorder() {
      let obj = {
        makerphone: this.orderNumber, // 创客手机号
        phone: this.khphone, // 客户手机号
        pid: this.provinceId, // 省份ID
        cid: this.cityId, // 城市ID
        pageindex: this.pageIndexOne,
        pagesize: 10
      };
      usercustomergetlist(obj).then(data => {
        if(data.resultCode == 1){
          this.chargebackList = data.resultObj.list;
          this.totalOne = data.resultObj.totalcount;
        }else{
          this.chargebackList = [];
          this.totalOne = 0;
        }
      })
    },
    // 分页
    currentchangeOne(val) {
      this.pageIndexOne = val;
      this.getorder();
    },
    selectItem(index) {
      this.selectedIndex = index;
    },
    // 编辑
    addPartner(row){
      this.czssq(); // 获取详情省市区
      this.customerid = row.customerid; // 客户ID
      this.isInfor = true;
      // this.fetchOptions(row.id);
      
      // 编辑回显数据 - 调用回显接口
      customergetinfo('', this.customerid).then(data => {
        if(data.resultCode == 1){
          this.khxqInfo = data.resultObj;
          this.createtime = this.khxqInfo.createtime; // 登记日期
          this.khname = this.khxqInfo.customername;
          this.sjhm = this.khxqInfo.phone;
          this.szcsid = [this.khxqInfo.provinceid,this.khxqInfo.cityid,this.khxqInfo.countyid];
          this.xqname = this.khxqInfo.address;
          this.fwhx = this.khxqInfo.housetypename;
          this.fwmj = this.khxqInfo.floorspace;
          this.khxqOption = this.khxqInfo.cluetypelist.map(option => ({
            ...option,
            selected: true // 添加 selected 属性并初始化为 true
          }));
          // this.cyclename = this.khxqInfo.cyclename; // 需求周期
          this.items.map(item => {
            if(item.days == this.khxqInfo.cyclename){
              this.selectedIndex = item.id - 1;
            }
          })
          this.desc = this.khxqInfo.remark; // 需求描述
          this.youxiao = this.khxqInfo.status; // 状态：1=有效 2=已过期 3=无效
        }
      });
    },
    // 客户需求字典
    fetchOptions(rowid) {
      let obj = {
        pid: this.provinceId, // 省份ID
        cid: this.cityId, // 城市ID
      };
      cluegettypes(obj).then(data => {
        if(data.resultCode == 1){
          this.khxqOption = data.resultObj;
        }
      });
    },
    // 确定编辑
    editSubmit(){
      let unselectedIds = this.khxqOption.filter(option => !option.selected).map(option => option.cluetypeid);
      let obj = {
        customerid: this.customerid, // 客户ID
        cluetypes: unselectedIds, // 需要设为无效的需求ID集合
        isinvalid: this.invalidCustomer==true?1:0, // 客户是否设为无效 0=否 1=是
      };
      customerchan(obj).then(data => {
        if(data.resultCode == 1){
          this.$swal({
            type:"success",
            text:"操作成功"
          })
          this.getorder();
          this.isInfor = false;
        }else{
          this.$swal({
            type:'error',
            text: data.resultMsg,
          })
        }
      })
    },
    // 销售记录
    showBillWatch(row) {
      this.isBillWatch = true;
      this.customerid = row.customerid; // 客户ID
      this.getpiaoju();
    },
    // 销售记录
    getpiaoju() {
      let obj = {
        customerid: this.customerid, // 客户ID
        pageindex: this.pageIndexXsjl,
        pagesize: 10,
      };
      getsellrecord(obj).then(data => {
        if(data.resultCode == 1){
          this.seeLlnrList = data.resultObj.list;
          this.pagetotal = data.resultObj.totalcount;
        }else{
          this.seeLlnrList = [];
          this.pagetotal = 0;
        }
      })
    },
    // 销售记录-分页
    handlethjl(val){
      this.pageIndexXsjl = val;
      this.getpiaoju();
    },
    // 获取销售记录列表
    gethmd() {
      let obj = {
        keyword: this.shangjianame, // 商家名称
        shopname: this.shztid, // 店铺名称 模糊匹配
        bdate: this.beginTime, // 开始
        edate: this.endTime, // 结束
        pageindex: this.pageIndexTwo,
        pagesize: 10
      };
      shopcustomercluegetlist(obj).then(data => {
        if(data.resultCode == 1){
          this.blacklist = data.resultObj.list;
          this.totalTwo = data.resultObj.totalcount;
        }else{
          this.blacklist = [];
          this.totalTwo = 0;
        }
      })
    },
    // 分页
    currentchangeTwo(val) {
      this.pageIndexTwo = val;
      this.gethmd();
    },
    // 获取登记黑名单列表
    getdjhmd() {
      let obj = {
        phone: this.chuangkephone, // 客户手机号
        isblacklist: this.djztid, // 登记状态0=全部 1=黑名单 2=正常
        pid: this.provinceId, // 省份ID
        cid: this.cityId, // 城市ID
        pageindex: this.pageIndexthree,
        pagesize: 10
      };
      djhmdpostlist(obj).then(data => {
        if(data.resultCode == 1){
          this.djhmdlist = data.resultObj.list;
          this.totalthree = data.resultObj.totalcount;
        }else{
          this.djhmdlist = [];
          this.totalthree = 0;
        }
      })
    },
    // 分页
    currentchangethree(val) {
      this.pageIndexthree = val;
      this.getdjhmd();
    },
    // 加入/移除 黑名单
    handlehmd(row){
      this.$swal({
        type: "warning",
        text: row.status == 1 ? "是否执行取消黑名单操作" : "是否执行设为黑名单操作",
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      }).then(res => {
        if (res.value) {
          let obj = {
            userid: row.userid, // 用户(创客)ID
            status: row.status==1?2:1,
          }
          qxdjhmd(obj).then(data=>{
            if(data.resultCode == 1){
              this.getdjhmd();
              this.$swal({
                type:"success",
                text:"操作成功"
              })
            }
          })
        }
      });
    },
    // 重置
    fnReset() {
      this.chuangkephone = "";
      this.djztid = 0;
      this.chengshi = '', // 省份城市
      this.provinceId = 0; // 省
      this.cityId = 0; // 市
    },
    // 申请时间
    changetime() {
      if(this.orderTime + "" == "null"){
        this.orderTime = ["",""]
      }
      this.beginTime = this.orderTime[0];
      this.endTime = this.orderTime[1];
    },
    // 查询店铺
    tankuang(){
      let addParams = {
        userId: localStorage.Id, // 当前登陆人id
      };
      userIdentity(addParams).then(data => {
        if (data.resultCode == 1) {
          this.shztArr = data.resultObj;
          this.shztArr.unshift({
            id: '',
            name: "全部",
          });
        }
      })
    },
    // 检索区域 省份城市
    handleChange(val) {
      this.provinceId = val[0];
      this.cityId = val[1];
    },
    // 查找省市
    getprovince() {
      let loginParams = {
        isopen: -1, // 是否开放 -1=查全部 1=开放、0=未开放
      };
      provincegetcountys(loginParams).then(data => {
        let that = this;
        let provinceAndCityAndarea = [];
        data.resultObj.forEach(item => {
          // 省
          let provinceData = {value:item.pid,label:item.pname,children:[]};
          provinceAndCityAndarea.push(provinceData);
          // 市
          item.citys.map(city => {
            let cityData = {value:city.cid, label:city.cname};
            provinceData.children.push(cityData);
          })
        });
        provinceAndCityAndarea.unshift({ value: 0, label: '全国',});
        that.options = provinceAndCityAndarea;
      })
    },
    // 请选择省市
    changeszcs(val) {
      this.shengId = val[0]; // 省
      this.shiId = val[1]; // 市
      this.qxId = val[2]; // 区
    },
    // 查找省市区
    czssq() {
      let loginParams = {
        isopen: 1, // 是否开放 -1=查全部 1=开放、0=未开放
      };
      provincegetcountys(loginParams).then(data => {
        const provinceOptions = [];
        data.resultObj.forEach(item => {
          const province = { value: item.pid, label: item.pname, children: [] };
          item.citys.forEach(city => {
            const cityObj = {
              value: city.cid, label: city.cname,
              children: city.countys.map(zone => ({
                value: zone.scid, label: zone.scname
              }))
            };
            province.children.push(cityObj);
          });
          provinceOptions.push(province);
        });
        this.csOptions = provinceOptions;
      }).catch(error => {
        console.error('获取省市区数据失败:', error);
      });
    },
    
  },
  mounted() {
    this.getorder();
    this.getprovince(); // 省市
    this.tankuang(); // 查询店铺
  }
};
</script>
<style scoped>
.khxqcheckbox{
  min-width: 42px;
  height: 38px;
  line-height: 38px;
  background: #F5F7FA;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border: 1px solid #DCDFE6;
  text-align: center;
  margin-right: -1px;
}
.khxqspan{
  display: block;
  min-width: 90px;
  height: 38px;
  line-height: 38px;
  background: #F5F7FA;
  border: 1px solid #DCDFE6;
  text-align: center;
  margin-right: -2px;
  z-index: 999;
}
.xqzqclass {
  width: 80px;
  height: 30px;
  margin: 0 10px 10px 0;
  text-align: center;
  background-color: #ccc;
  color: white;
  cursor: pointer;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: normal; /* 允许文本换行 */
  word-break: break-all; /* 确保长文本也能换行 */
}

.xqzqclass.selected {
  background-color: #F56C6C;
}
</style>


// WEBPACK FOOTER //
// beginners.vue?3c3a81bb